import { serializable, alias, object, list, primitive } from 'serializr';

export class TotalCarbonEmissionProducts {
  @serializable(alias('total_co2e', primitive()))
  totalCo2e?: number;
}
